class GoogleAnalytics {
  logEvent(eventName, data = {}) {
    if (window.gtag && window._commercegaID) {
      return window.gtag('event', eventName, { send_to: window._commercegaID, ...data });
    }
  }
}

export default new GoogleAnalytics();
